export function SortingIcon({ ascend, descend }) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.367929"
        y="0.368387"
        width="19.8935"
        height="18.4199"
        rx="1.84199"
        fill="white"
      />
      <rect
        x="0.367929"
        y="0.368387"
        width="19.8935"
        height="18.4199"
        rx="1.84199"
        stroke="#006AB3"
        stroke-width="0.736798"
      />
      <path
        d="M4.39361 8.23677C4.19911 8.04221 4.08984 7.77836 4.08984 7.50325C4.08984 7.22814 4.19911 6.9643 4.39361 6.76974L7.50613 3.65722C7.65122 3.51217 7.83607 3.41339 8.0373 3.37338C8.23852 3.33336 8.4471 3.35391 8.63665 3.43242C8.8262 3.51093 8.98822 3.64387 9.10223 3.81445C9.21623 3.98502 9.2771 4.18557 9.27715 4.39074V14.7658C9.27716 14.902 9.25034 15.037 9.19821 15.1629C9.14608 15.2888 9.06966 15.4031 8.97331 15.4995C8.87697 15.5958 8.76259 15.6723 8.63671 15.7244C8.51082 15.7766 8.3759 15.8034 8.23964 15.8034C8.10338 15.8034 7.96846 15.7766 7.84258 15.7244C7.71669 15.6723 7.60231 15.5958 7.50597 15.4995C7.40963 15.4031 7.33321 15.2888 7.28108 15.1629C7.22894 15.037 7.20212 14.902 7.20214 14.7658V6.89527L5.86064 8.23677C5.66608 8.43127 5.40224 8.54054 5.12713 8.54054C4.85202 8.54054 4.58817 8.43127 4.39361 8.23677Z"
        fill={ascend ? "black" : "#A2A2A6"}
      />
      <path
        d="M16.2351 10.9198C16.4296 11.1144 16.5389 11.3782 16.5389 11.6533C16.5389 11.9285 16.4296 12.1923 16.2351 12.3869L13.1226 15.4994C12.9775 15.6444 12.7926 15.7432 12.5914 15.7832C12.3902 15.8232 12.1816 15.8027 11.9921 15.7242C11.8025 15.6457 11.6405 15.5127 11.5265 15.3421C11.4125 15.1716 11.3516 14.971 11.3516 14.7659V4.39081C11.3515 4.25455 11.3784 4.11963 11.4305 3.99374C11.4826 3.86785 11.5591 3.75346 11.6554 3.6571C11.7517 3.56075 11.8661 3.48431 11.992 3.43217C12.1179 3.38002 12.2528 3.35318 12.3891 3.35318C12.5253 3.35318 12.6602 3.38002 12.7861 3.43217C12.912 3.48431 13.0264 3.56075 13.1227 3.6571C13.2191 3.75346 13.2955 3.86785 13.3476 3.99374C13.3998 4.11963 13.4266 4.25455 13.4266 4.39081V12.2613L14.7681 10.9198C14.9626 10.7253 15.2265 10.6161 15.5016 10.6161C15.7767 10.6161 16.0405 10.7253 16.2351 10.9198Z"
        fill={descend ? "black" : "#A2A2A6"}
      />
    </svg>
  );
}
